"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZA = void 0;
exports.ZA = {
    numericCode: '710',
    alpha2Code: 'ZA',
    alpha3Code: 'ZAF',
    englishName: {
        short: 'South Africa',
        full: 'the Republic of South Africa',
    },
    names: {
        full: {
            en: 'the Republic of South Africa',
            fr: 'la République sud-africaine',
            af: 'Suid-Afrika',
            nr: 'Sewula Afrika',
            '': 'Afrika-Borwa',
            st: 'Afrika-Borwa',
            ss: 'Ningizimu Afrika',
            tn: 'Afrika-Borwa',
            ts: 'Afrika-Dzonga',
            ve: 'Afrika Tshipembe',
            xh: 'Mzantsi Afrika',
            zu: 'Ningizimu Afrika',
        },
        short: {
            en: 'South Africa',
            fr: "Afrique du Sud (l')",
            af: 'Suid-Afrika',
            nr: 'Sewula Afrika',
            '': 'Afrika-Borwa',
            st: 'Afrika-Borwa',
            ss: 'Ningizimu Afrika',
            tn: 'Afrika-Borwa',
            ts: 'Afrika-Dzonga',
            ve: 'Afrika Tshipembe',
            xh: 'Mzantsi Afrika',
            zu: 'Ningizimu Afrika',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'af',
            languageAlpha3Code: 'afr',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'nr',
            languageAlpha3Code: 'nbl',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: '',
            languageAlpha3Code: 'nso',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'st',
            languageAlpha3Code: 'sot',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'ss',
            languageAlpha3Code: 'ssw',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'tn',
            languageAlpha3Code: 'tsn',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'ts',
            languageAlpha3Code: 'tso',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 've',
            languageAlpha3Code: 'ven',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'xh',
            languageAlpha3Code: 'xho',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'zu',
            languageAlpha3Code: 'zul',
            isAdministrative: true,
        },
    ],
    subdivisions: {
        'ZA-EC': {
            numericCode: '710',
            code: 'ZA-EC',
            category: {
                id: '428',
                names: {
                    af: {
                        singular: 'provinsie',
                        plural: '',
                    },
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    nr: {
                        singular: 'iProvinsi',
                        plural: '',
                    },
                    '': {
                        singular: 'profense',
                        plural: '',
                    },
                    st: {
                        singular: 'provense',
                        plural: '',
                    },
                    ss: {
                        singular: 'fundzeni',
                        plural: '',
                    },
                    tn: {
                        singular: 'porofense',
                        plural: '',
                    },
                    ts: {
                        singular: 'fundzankulu',
                        plural: '',
                    },
                    ve: {
                        singular: 'vundu',
                        plural: '',
                    },
                    xh: {
                        singular: 'phondo',
                        plural: '',
                    },
                    zu: {
                        singular: 'fundazwe',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                af: 'Oos-Kaap',
                en: 'Eastern Cape',
                nr: 'iPumalanga-Kapa',
                '': 'Kapa Bohlabela',
                st: 'Kapa Botjhabela',
                tn: 'Kapa Botlhaba',
                ts: 'Kapa-Vuxa',
                ve: 'Kapa Vhubvaḓuvha',
                xh: 'Mpuma-Koloni',
                zu: 'Mpumalanga-Kapa',
            },
        },
        'ZA-FS': {
            numericCode: '710',
            code: 'ZA-FS',
            category: {
                id: '428',
                names: {
                    af: {
                        singular: 'provinsie',
                        plural: '',
                    },
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    nr: {
                        singular: 'iProvinsi',
                        plural: '',
                    },
                    '': {
                        singular: 'profense',
                        plural: '',
                    },
                    st: {
                        singular: 'provense',
                        plural: '',
                    },
                    ss: {
                        singular: 'fundzeni',
                        plural: '',
                    },
                    tn: {
                        singular: 'porofense',
                        plural: '',
                    },
                    ts: {
                        singular: 'fundzankulu',
                        plural: '',
                    },
                    ve: {
                        singular: 'vundu',
                        plural: '',
                    },
                    xh: {
                        singular: 'phondo',
                        plural: '',
                    },
                    zu: {
                        singular: 'fundazwe',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                af: 'Vrystaat',
                en: 'Free State',
                nr: 'iFreyistata',
                '': 'Freistata',
                st: 'Freistata',
                tn: 'Foreisetata',
                ts: 'Free State',
                ve: 'Fureisitata',
                xh: 'Freyistata',
                zu: 'Fuleyisitata',
            },
        },
        'ZA-GP': {
            numericCode: '710',
            code: 'ZA-GP',
            category: {
                id: '428',
                names: {
                    af: {
                        singular: 'provinsie',
                        plural: '',
                    },
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    nr: {
                        singular: 'iProvinsi',
                        plural: '',
                    },
                    '': {
                        singular: 'profense',
                        plural: '',
                    },
                    st: {
                        singular: 'provense',
                        plural: '',
                    },
                    ss: {
                        singular: 'fundzeni',
                        plural: '',
                    },
                    tn: {
                        singular: 'porofense',
                        plural: '',
                    },
                    ts: {
                        singular: 'fundzankulu',
                        plural: '',
                    },
                    ve: {
                        singular: 'vundu',
                        plural: '',
                    },
                    xh: {
                        singular: 'phondo',
                        plural: '',
                    },
                    zu: {
                        singular: 'fundazwe',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                af: 'Gauteng',
                en: 'Gauteng',
                nr: 'iGauteng',
                '': 'Gauteng',
                st: 'Kgauteng',
                ss: 'Gauteng',
                tn: 'Gauteng',
                ts: 'Gauteng',
                ve: 'Gauteng',
                xh: 'Rhawuti',
                zu: 'Gauteng',
            },
        },
        'ZA-KZN': {
            numericCode: '710',
            code: 'ZA-KZN',
            category: {
                id: '428',
                names: {
                    af: {
                        singular: 'provinsie',
                        plural: '',
                    },
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    nr: {
                        singular: 'iProvinsi',
                        plural: '',
                    },
                    '': {
                        singular: 'profense',
                        plural: '',
                    },
                    st: {
                        singular: 'provense',
                        plural: '',
                    },
                    ss: {
                        singular: 'fundzeni',
                        plural: '',
                    },
                    tn: {
                        singular: 'porofense',
                        plural: '',
                    },
                    ts: {
                        singular: 'fundzankulu',
                        plural: '',
                    },
                    ve: {
                        singular: 'vundu',
                        plural: '',
                    },
                    xh: {
                        singular: 'phondo',
                        plural: '',
                    },
                    zu: {
                        singular: 'fundazwe',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                af: 'KwaZulu-Natal',
                en: 'Kwazulu-Natal',
                nr: 'iKwaZulu-Natal',
                '': 'GaZulu-Natala',
                st: 'Hazolo-Natala',
                ss: 'KwaZulu-Natali',
                tn: 'KwaZulu-Natal',
                ts: 'Kwazulu-Natal',
                ve: 'HaZulu-Natal',
                xh: 'KwaZulu-Natala',
                zu: 'KwaZulu-Natali',
            },
        },
        'ZA-LP': {
            numericCode: '710',
            code: 'ZA-LP',
            category: {
                id: '428',
                names: {
                    af: {
                        singular: 'provinsie',
                        plural: '',
                    },
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    nr: {
                        singular: 'iProvinsi',
                        plural: '',
                    },
                    '': {
                        singular: 'profense',
                        plural: '',
                    },
                    st: {
                        singular: 'provense',
                        plural: '',
                    },
                    ss: {
                        singular: 'fundzeni',
                        plural: '',
                    },
                    tn: {
                        singular: 'porofense',
                        plural: '',
                    },
                    ts: {
                        singular: 'fundzankulu',
                        plural: '',
                    },
                    ve: {
                        singular: 'vundu',
                        plural: '',
                    },
                    xh: {
                        singular: 'phondo',
                        plural: '',
                    },
                    zu: {
                        singular: 'fundazwe',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                af: 'Limpopo',
                en: 'Limpopo',
                nr: 'Limpopo',
                '': 'Limpopo',
                st: 'Limpopo',
                ss: 'Limpopo',
                tn: 'Limpopo',
                ts: 'Limpopo',
                ve: 'Vhembe',
                xh: 'Limpopo',
                zu: 'Limpopo',
            },
        },
        'ZA-MP': {
            numericCode: '710',
            code: 'ZA-MP',
            category: {
                id: '428',
                names: {
                    af: {
                        singular: 'provinsie',
                        plural: '',
                    },
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    nr: {
                        singular: 'iProvinsi',
                        plural: '',
                    },
                    '': {
                        singular: 'profense',
                        plural: '',
                    },
                    st: {
                        singular: 'provense',
                        plural: '',
                    },
                    ss: {
                        singular: 'fundzeni',
                        plural: '',
                    },
                    tn: {
                        singular: 'porofense',
                        plural: '',
                    },
                    ts: {
                        singular: 'fundzankulu',
                        plural: '',
                    },
                    ve: {
                        singular: 'vundu',
                        plural: '',
                    },
                    xh: {
                        singular: 'phondo',
                        plural: '',
                    },
                    zu: {
                        singular: 'fundazwe',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                af: 'Mpumalanga',
                en: 'Mpumalanga',
                nr: 'iMpumalanga',
                '': 'Mpumalanga',
                st: 'Mpumalanga',
                ss: 'Mpumalanga',
                tn: 'Mpumalanga',
                ts: 'Mpumalanga',
                ve: 'Mpumalanga',
                xh: 'Mpumalanga',
                zu: 'Mpumalanga',
            },
        },
        'ZA-NC': {
            numericCode: '710',
            code: 'ZA-NC',
            category: {
                id: '428',
                names: {
                    af: {
                        singular: 'provinsie',
                        plural: '',
                    },
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    nr: {
                        singular: 'iProvinsi',
                        plural: '',
                    },
                    '': {
                        singular: 'profense',
                        plural: '',
                    },
                    st: {
                        singular: 'provense',
                        plural: '',
                    },
                    ss: {
                        singular: 'fundzeni',
                        plural: '',
                    },
                    tn: {
                        singular: 'porofense',
                        plural: '',
                    },
                    ts: {
                        singular: 'fundzankulu',
                        plural: '',
                    },
                    ve: {
                        singular: 'vundu',
                        plural: '',
                    },
                    xh: {
                        singular: 'phondo',
                        plural: '',
                    },
                    zu: {
                        singular: 'fundazwe',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                af: 'Noord-Kaap',
                en: 'Northern Cape',
                nr: 'iTlhagwini-Kapa',
                '': 'Kapa Leboya',
                st: 'Kapa Leboya',
                tn: 'Kapa Bokone',
                ts: "Kapa-N'walungu",
                ve: 'Kapa Devhula',
                xh: 'Mntla-Koloni',
                zu: 'Nyakatho-Kapa',
            },
        },
        'ZA-NW': {
            numericCode: '710',
            code: 'ZA-NW',
            category: {
                id: '428',
                names: {
                    af: {
                        singular: 'provinsie',
                        plural: '',
                    },
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    nr: {
                        singular: 'iProvinsi',
                        plural: '',
                    },
                    '': {
                        singular: 'profense',
                        plural: '',
                    },
                    st: {
                        singular: 'provense',
                        plural: '',
                    },
                    ss: {
                        singular: 'fundzeni',
                        plural: '',
                    },
                    tn: {
                        singular: 'porofense',
                        plural: '',
                    },
                    ts: {
                        singular: 'fundzankulu',
                        plural: '',
                    },
                    ve: {
                        singular: 'vundu',
                        plural: '',
                    },
                    xh: {
                        singular: 'phondo',
                        plural: '',
                    },
                    zu: {
                        singular: 'fundazwe',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                af: 'Noordwes',
                en: 'North-West',
                nr: 'iTlhagwini-Tjhingalanga',
                '': 'Lebowa Bodikela',
                st: 'Leboya (le) Bophirima',
                tn: 'Bokone Bophirima',
                ts: "N'walungu-Vupeladyambu",
                xh: 'Mntla-Ntshona',
                zu: 'Nyakatho-Ntshonalanga',
            },
        },
        'ZA-WC': {
            numericCode: '710',
            code: 'ZA-WC',
            category: {
                id: '428',
                names: {
                    af: {
                        singular: 'provinsie',
                        plural: '',
                    },
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    nr: {
                        singular: 'iProvinsi',
                        plural: '',
                    },
                    '': {
                        singular: 'profense',
                        plural: '',
                    },
                    st: {
                        singular: 'provense',
                        plural: '',
                    },
                    ss: {
                        singular: 'fundzeni',
                        plural: '',
                    },
                    tn: {
                        singular: 'porofense',
                        plural: '',
                    },
                    ts: {
                        singular: 'fundzankulu',
                        plural: '',
                    },
                    ve: {
                        singular: 'vundu',
                        plural: '',
                    },
                    xh: {
                        singular: 'phondo',
                        plural: '',
                    },
                    zu: {
                        singular: 'fundazwe',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                af: 'Wes-Kaap',
                en: 'Western Cape',
                nr: 'iTjhingalanga-Kapa',
                '': 'Kapa Bodikela',
                st: 'Kapa Bophirimela',
                tn: 'Kapa Bophirima',
                ts: 'Kapa-Vupeladyambu',
                ve: 'Kapa Vhukovhela',
                xh: 'Ntshona-Koloni',
                zu: 'Ntshonalanga-Kapa',
            },
        },
    },
    cities: [
        {
            name: 'Roodepoort',
            subdivision: 'Gauteng',
        },
        {
            name: 'Zeerust',
            subdivision: 'North-West',
        },
        {
            name: 'Wolmaransstad',
            subdivision: 'North-West',
        },
        {
            name: 'White River',
            subdivision: 'Mpumalanga',
        },
        {
            name: 'Witbank',
            subdivision: 'Mpumalanga',
        },
        {
            name: 'Westonaria',
            subdivision: 'Gauteng',
        },
        {
            name: 'Wesselsbron',
            subdivision: 'Orange Free State',
        },
        {
            name: 'Welkom',
            subdivision: 'Orange Free State',
        },
        {
            name: 'Warrenton',
            subdivision: 'Northern Cape',
        },
        {
            name: 'Warmbaths',
            subdivision: 'Limpopo',
        },
        {
            name: 'Vryheid',
            subdivision: 'KwaZulu-Natal',
        },
        {
            name: 'Vryburg',
            subdivision: 'North-West',
        },
        {
            name: 'Volksrust',
            subdivision: 'Mpumalanga',
        },
        {
            name: 'Virginia',
            subdivision: 'Orange Free State',
        },
        {
            name: 'Viljoenskroon',
            subdivision: 'Orange Free State',
        },
        {
            name: 'Vereeniging',
            subdivision: 'Gauteng',
        },
        {
            name: 'Vanderbijlpark',
            subdivision: 'Gauteng',
        },
        {
            name: 'Upington',
            subdivision: 'Northern Cape',
        },
        {
            name: 'Mthatha',
            subdivision: 'Eastern Cape',
        },
        {
            name: 'Umkomaas',
            subdivision: 'KwaZulu-Natal',
        },
        {
            name: 'Ulundi',
            subdivision: 'KwaZulu-Natal',
        },
        {
            name: 'Uitenhage',
            subdivision: 'Eastern Cape',
        },
        {
            name: 'Tzaneen',
            subdivision: 'Limpopo',
        },
        {
            name: 'Thohoyandou',
            subdivision: 'Limpopo',
        },
        {
            name: 'Theunissen',
            subdivision: 'Orange Free State',
        },
        {
            name: 'Thaba Nchu',
            subdivision: 'Orange Free State',
        },
        {
            name: 'Tembisa',
            subdivision: 'Gauteng',
        },
        {
            name: 'Stutterheim',
            subdivision: 'Eastern Cape',
        },
        {
            name: 'Stilfontein',
            subdivision: 'North-West',
        },
        {
            name: 'Stanger',
            subdivision: 'KwaZulu-Natal',
        },
        {
            name: 'Standerton',
            subdivision: 'Mpumalanga',
        },
        {
            name: 'Springs',
            subdivision: 'Gauteng',
        },
        {
            name: 'Soweto',
            subdivision: 'Gauteng',
        },
        {
            name: 'Somerset East',
            subdivision: 'Eastern Cape',
        },
        {
            name: 'Siyabuswa',
            subdivision: 'Mpumalanga',
        },
        {
            name: 'Senekal',
            subdivision: 'Orange Free State',
        },
        {
            name: 'Secunda',
            subdivision: 'Mpumalanga',
        },
        {
            name: 'Scottburgh',
            subdivision: 'KwaZulu-Natal',
        },
        {
            name: 'Schweizer-Reneke',
            subdivision: 'North-West',
        },
        {
            name: 'Sasolburg',
            subdivision: 'Orange Free State',
        },
        {
            name: 'Rustenburg',
            subdivision: 'North-West',
        },
        {
            name: 'Richmond',
            subdivision: 'KwaZulu-Natal',
        },
        {
            name: 'Richards Bay',
            subdivision: 'KwaZulu-Natal',
        },
        {
            name: 'Reitz',
            subdivision: 'Orange Free State',
        },
        {
            name: 'Randfontein',
            subdivision: 'Gauteng',
        },
        {
            name: 'Queenstown',
            subdivision: 'Eastern Cape',
        },
        {
            name: 'Queensdale',
            subdivision: 'Eastern Cape',
        },
        {
            name: 'Pretoria',
            subdivision: 'Gauteng',
        },
        {
            name: 'Mokopane',
            subdivision: 'Limpopo',
        },
        {
            name: 'Potchefstroom',
            subdivision: 'North-West',
        },
        {
            name: 'Port Shepstone',
            subdivision: 'KwaZulu-Natal',
        },
        {
            name: 'Port Elizabeth',
            subdivision: 'Eastern Cape',
        },
        {
            name: 'Port Alfred',
            subdivision: 'Eastern Cape',
        },
        {
            name: 'Plettenberg Bay',
            subdivision: 'Western Cape',
        },
        {
            name: 'Piet Retief',
            subdivision: 'Mpumalanga',
        },
        {
            name: 'Polokwane',
            subdivision: 'Limpopo',
        },
        {
            name: 'Pietermaritzburg',
            subdivision: 'KwaZulu-Natal',
        },
        {
            name: 'Phuthaditjhaba',
            subdivision: 'Orange Free State',
        },
        {
            name: 'Phalaborwa',
            subdivision: 'Limpopo',
        },
        {
            name: 'Parys',
            subdivision: 'Orange Free State',
        },
        {
            name: 'Pampierstad',
            subdivision: 'North-West',
        },
        {
            name: 'Oudtshoorn',
            subdivision: 'Western Cape',
        },
        {
            name: 'Orkney',
            subdivision: 'North-West',
        },
        {
            name: 'Modimolle',
            subdivision: 'Limpopo',
        },
        {
            name: 'Nkowakowa',
            subdivision: 'Limpopo',
        },
        {
            name: 'Nigel',
            subdivision: 'Gauteng',
        },
        {
            name: 'Newcastle',
            subdivision: 'KwaZulu-Natal',
        },
        {
            name: 'Nelspruit',
            subdivision: 'Mpumalanga',
        },
        {
            name: 'Mpumalanga',
            subdivision: 'KwaZulu-Natal',
        },
        {
            name: 'Mpophomeni',
            subdivision: 'KwaZulu-Natal',
        },
        {
            name: 'Mossel Bay',
            subdivision: 'Western Cape',
        },
        {
            name: 'Mondlo',
            subdivision: 'KwaZulu-Natal',
        },
        {
            name: 'Mmabatho',
            subdivision: 'North-West',
        },
        {
            name: 'Middelburg',
            subdivision: 'Eastern Cape',
        },
        {
            name: 'Middelburg',
            subdivision: 'Mpumalanga',
        },
        {
            name: 'Messina',
            subdivision: 'Limpopo',
        },
        {
            name: 'Margate',
            subdivision: 'KwaZulu-Natal',
        },
        {
            name: 'Mabopane',
            subdivision: 'Gauteng',
        },
        {
            name: 'Lydenburg',
            subdivision: 'Mpumalanga',
        },
        {
            name: 'Louis Trichardt',
            subdivision: 'Limpopo',
        },
        {
            name: 'Lichtenburg',
            subdivision: 'North-West',
        },
        {
            name: 'Lebowakgomo',
            subdivision: 'Limpopo',
        },
        {
            name: 'Lady Frere',
            subdivision: 'Eastern Cape',
        },
        {
            name: 'Ladybrand',
            subdivision: 'Orange Free State',
        },
        {
            name: 'Kutloanong',
            subdivision: 'Orange Free State',
        },
        {
            name: 'Kruisfontein',
            subdivision: 'Eastern Cape',
        },
        {
            name: 'Krugersdorp',
            subdivision: 'Gauteng',
        },
        {
            name: 'Kroonstad',
            subdivision: 'Orange Free State',
        },
        {
            name: 'Kriel',
            subdivision: 'Mpumalanga',
        },
        {
            name: 'Komatipoort',
            subdivision: 'Mpumalanga',
        },
        {
            name: 'Kokstad',
            subdivision: 'KwaZulu-Natal',
        },
        {
            name: 'Knysna',
            subdivision: 'Western Cape',
        },
        {
            name: 'Klerksdorp',
            subdivision: 'North-West',
        },
        {
            name: 'Kimberley',
            subdivision: 'Northern Cape',
        },
        {
            name: 'Johannesburg',
            subdivision: 'Gauteng',
        },
        {
            name: 'Howick',
            subdivision: 'KwaZulu-Natal',
        },
        {
            name: 'Hennenman',
            subdivision: 'Orange Free State',
        },
        {
            name: 'Hendrina',
            subdivision: 'Mpumalanga',
        },
        {
            name: 'Heilbron',
            subdivision: 'Orange Free State',
        },
        {
            name: 'Heidelberg',
            subdivision: 'Gauteng',
        },
        {
            name: 'Harrismith',
            subdivision: 'Orange Free State',
        },
        {
            name: 'Grahamstown',
            subdivision: 'Eastern Cape',
        },
        {
            name: 'Graaff-Reinet',
            subdivision: 'Eastern Cape',
        },
        {
            name: 'Giyani',
            subdivision: 'Limpopo',
        },
        {
            name: 'George',
            subdivision: 'Western Cape',
        },
        {
            name: 'Ga-Rankuwa',
            subdivision: 'North-West',
        },
        {
            name: 'Fort Beaufort',
            subdivision: 'Eastern Cape',
        },
        {
            name: 'Fochville',
            subdivision: 'North-West',
        },
        {
            name: 'eSikhawini',
            subdivision: 'KwaZulu-Natal',
        },
        {
            name: 'Ermelo',
            subdivision: 'Mpumalanga',
        },
        {
            name: 'Empangeni',
            subdivision: 'KwaZulu-Natal',
        },
        {
            name: 'eMbalenhle',
            subdivision: 'Mpumalanga',
        },
        {
            name: 'East London',
            subdivision: 'Eastern Cape',
        },
        {
            name: 'Durban',
            subdivision: 'KwaZulu-Natal',
        },
        {
            name: 'Dundee',
            subdivision: 'KwaZulu-Natal',
        },
        {
            name: 'Duiwelskloof',
            subdivision: 'Limpopo',
        },
        {
            name: 'Driefontein',
            subdivision: 'Mpumalanga',
        },
        {
            name: 'Delmas',
            subdivision: 'Mpumalanga',
        },
        {
            name: 'De Aar',
            subdivision: 'Northern Cape',
        },
        {
            name: 'Cullinan',
            subdivision: 'Gauteng',
        },
        {
            name: 'Cradock',
            subdivision: 'Eastern Cape',
        },
        {
            name: 'Christiana',
            subdivision: 'North-West',
        },
        {
            name: 'Carletonville',
            subdivision: 'Gauteng',
        },
        {
            name: 'Butterworth',
            subdivision: 'Eastern Cape',
        },
        {
            name: 'Bronkhorstspruit',
            subdivision: 'Gauteng',
        },
        {
            name: 'Brits',
            subdivision: 'North-West',
        },
        {
            name: 'Brakpan',
            subdivision: 'Gauteng',
        },
        {
            name: 'Botshabelo',
            subdivision: 'Orange Free State',
        },
        {
            name: 'Bothaville',
            subdivision: 'Orange Free State',
        },
        {
            name: 'Boksburg',
            subdivision: 'Gauteng',
        },
        {
            name: 'Bloemhof',
            subdivision: 'North-West',
        },
        {
            name: 'Bloemfontein',
            subdivision: 'Orange Free State',
        },
        {
            name: 'Bhisho',
            subdivision: 'Eastern Cape',
        },
        {
            name: 'Bethlehem',
            subdivision: 'Orange Free State',
        },
        {
            name: 'Bethal',
            subdivision: 'Mpumalanga',
        },
        {
            name: 'Benoni',
            subdivision: 'Gauteng',
        },
        {
            name: 'Beaufort West',
            subdivision: 'Western Cape',
        },
        {
            name: 'Barberton',
            subdivision: 'Mpumalanga',
        },
        {
            name: 'Ballitoville',
            subdivision: 'KwaZulu-Natal',
        },
        {
            name: 'Balfour',
            subdivision: 'Mpumalanga',
        },
        {
            name: 'Allanridge',
            subdivision: 'Orange Free State',
        },
        {
            name: 'Aliwal North',
            subdivision: 'Eastern Cape',
        },
        {
            name: 'Ekangala',
            subdivision: 'Gauteng',
        },
        {
            name: 'Midrand',
            subdivision: 'Gauteng',
        },
        {
            name: 'Centurion',
            subdivision: 'Gauteng',
        },
        {
            name: 'Worcester',
            subdivision: 'Western Cape',
        },
        {
            name: 'Stellenbosch',
            subdivision: 'Western Cape',
        },
        {
            name: 'Saldanha',
            subdivision: 'Western Cape',
        },
        {
            name: 'Paarl',
            subdivision: 'Western Cape',
        },
        {
            name: 'Malmesbury',
            subdivision: 'Western Cape',
        },
        {
            name: 'Lansdowne',
            subdivision: 'Western Cape',
        },
        {
            name: 'Kraaifontein',
            subdivision: 'Western Cape',
        },
        {
            name: 'Hermanus',
            subdivision: 'Western Cape',
        },
        {
            name: 'Grabouw',
            subdivision: 'Western Cape',
        },
        {
            name: 'Ceres',
            subdivision: 'Western Cape',
        },
        {
            name: 'Cape Town',
            subdivision: 'Western Cape',
        },
        {
            name: 'Atlantis',
            subdivision: 'Western Cape',
        },
        {
            name: 'Rondebosch',
            subdivision: 'Western Cape',
        },
        {
            name: 'Retreat',
            subdivision: 'Western Cape',
        },
        {
            name: 'Diepsloot',
            subdivision: 'Gauteng',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,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